import { useEffect, useState } from "react";
import { Input } from "antd";
import { debounce, isEmpty, noop } from "lodash";
import classNames from "classnames";
import InputMask from "react-input-mask";
import { useDynamicFormStore } from "@stores/dynamicFormStore";

const InputField = (props: {
  className: any;
  value: any;
  validations: any;
  onBlur?: (arg0: string) => void;
  title: string;
  isRequired: any;
  isEditable: any;
  placeholder: any;
  handleRulesOnValueChange: any;
}) => {
  const [value, setValue] = useState(props.value);
  const [validField, setValidField] = useState(true);

  const { minLength, maxLength, fixedLength, mask } = props.validations;

  const [setIsInvalidFlag] = useDynamicFormStore((state) => [state.setIsInvalidFlag]);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleValue = (value: any) => {
    setValue(value);
    props.handleRulesOnValueChange(value);
    handleBlur(value);
  };

  const _minLength = minLength ? minLength : fixedLength ? fixedLength : 0;
  const _maxLength = maxLength ? maxLength : fixedLength ? fixedLength : 100;

  const handleBlur = debounce((_value: string) => {
    console.log("handleBlur", _value, _value.length, _minLength, _maxLength);
    if (!isEmpty(_value)) {
      if (_value?.trim().length >= _minLength && _value?.trim().length <= _maxLength) {
        setValidField(true);
        setIsInvalidFlag(false);
      } else {
        setIsInvalidFlag(true);
        setValidField(false);
      }
    } else {
      setValidField(true);
      setIsInvalidFlag(false);
    }
  }, 1000);

  const inputClassName = classNames(`${props.className}__input`, {
    [`${props.className}__input__mask`]: mask,
    [`${props.className}__input--red-border`]: !validField,
  });

  const validationMessage = _minLength === _maxLength ? `Please match the fixed length of ${_maxLength} characters.` : "Please enter correct input";

  const formatMaskInput = (value: any) => {
    if (!value) return "";

    const digits = value.replace(/\D/g, "");
    const groups = mask.split("-").map((group: any) => group.length);
    let maskedValue = "";

    let digitIndex = 0;
    for (const groupLength of groups) {
      for (let i = 0; i < groupLength; i++) {
        maskedValue += digits[digitIndex++] || "_";
      }
    }

    return maskedValue;
  };

  return (
    <>
      {mask ? (
        <InputMask
          placeholder={props.placeholder}
          mask={mask}
          maskPlaceholder={null}
          className={`ant-input  ${inputClassName}`}
          value={formatMaskInput(value)}
          onChange={(e) => handleValue(e.target.value?.replaceAll("_", ""))}
          onFocus={() => noop()}
        />
      ) : (
        <Input
          minLength={_minLength}
          maxLength={_maxLength}
          placeholder={props.placeholder}
          value={value}
          disabled={!props.isEditable}
          onChange={(e) => handleValue(e.target.value)}
          className={inputClassName}
          size="large"
        />
      )}

      {!validField && <h5 className="clr-e100">{validationMessage}</h5>}
    </>
  );
};

export default InputField;
